/**
 * @desc 我的收藏
 */
import React from 'react';
import { Link } from 'react-router';
import { Table } from 'antd';
import { ReportDateTypeText, ReportTypeText } from '../../../constants/info';
import messager from '../../../utils/messager';
import { dateFormat } from '../../../utils/formatter';
import { getPictureLink } from '../../../utils/util';
import Pagination from '../../common/pagination/Pagination';
import TableSearch from '../../common/tableSearch/TableSearch';
import SearchBar from '../common/searchBar/SearchBar';
import { getCollectList, cancelCollect } from '../../../services/user';

export default class Collect extends TableSearch {
    constructor(props) {
        super(props);
        this.server = getCollectList;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchParams: {},
            loading: true,
            data: []
        };
    }

    cancelCollect = ({ id }) => {
        cancelCollect({ id }).then(() => {
            messager.success('取消收藏成功');
            this.delRefresh();
        });
    };

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 100
        }, {
            title: '公司简称',
            dataIndex: 'sesName'
        }, {
            title: '财报年份',
            dataIndex: 'reportYear',
            width: 150
        }, {
            title: '财报类型',
            dataIndex: 'reportDateType',
            render: (v, d) => ReportDateTypeText[v] + ReportTypeText[d.reportType]
        }, {
            title: '收藏时间',
            dataIndex: 'gmtCreate',
            width: 100,
            render: dateFormat
        }, {
            title: '操作',
            dataIndex: 'operation',
            width: 180,
            render: (v, d) => <div className="operation">
                <Link target="_blank" rel="noopener noreferrer" to={getPictureLink(d)}>查看画像</Link>
                <a href="javascript:void(0)" className="orange-font" onClick={() => this.cancelCollect(d)}>取消收藏</a>
            </div>
        }];
    };

    render() {
        const { data, pageNum, pageSize, total, loading } = this.state;
        return (
            <div>
                <SearchBar onSearch={this.onSearch}/>

                <Table
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/collect/Index.jsx